import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, LocalCacheService, SpinnerService, ConfigurationService, IndexDbStorageService } from '../_shared/services/services-index';
import { Enums, IEnums } from '../_shared/enums/enums';
import { Subscription, EMPTY, of } from 'rxjs';
import { tap, catchError, filter, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../_store/app-state.model';
import { FilterActions } from '../_shared/filter/store';
import { AppActions } from '../_store/action-types';
import { AppSelectors } from '../_store/selector-types';

@Component({
    templateUrl: './ssologinV5.component.html',
    standalone: false
})

export class SsoLoginV5Component implements OnDestroy, OnInit {
  private subs: Subscription[] = [];
  response: any;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router,
    private store: Store<AppState>,
    private spinner: SpinnerService,
    private cache: LocalCacheService,
    private configService: ConfigurationService,
    private indexDbStorageService: IndexDbStorageService) {

  }

  ngOnInit() {
    this.store.dispatch(AppActions.resetAuth());
    this.store.dispatch(FilterActions.resetFilters());

    this.route.queryParams.subscribe(params => {
      const encodedResponse = params['response'];
      // console.log('encoded response', encodedResponse);

      // Decode the response
      this.response = JSON.parse(atob(encodedResponse));
      // console.log('decoded response', this.response);

      this.login();
    });
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  login(): void {
    this.cache.purgeAllLocalCaches();
    this.indexDbStorageService.purgeCache().subscribe();

    const sub = this.authService.loginCustomToken(this.response.accessToken, this.response.refreshToken).pipe(
      switchMap(() => this.store.select(AppSelectors.selectLoggedInUser)),
      filter(user => !!user),
      tap(user => console.log('logged in user', user)),
      tap(_ => this.store.dispatch(FilterActions.resetAllReportViewFilters())),
      catchError(err => {
        this.spinner.hide();
        console.error('sso login v5 error', err);
        return this.router.navigate(['/errors']);
      })).subscribe(() => {
        this.spinner.hide();
        this.router.navigateByUrl(this.configService.routing.defaultRoute);
      });

    this.subs.push(sub);
  }
}


